import React, { Fragment } from 'react';
import useFieldRevealTracker from '../hooks/useFieldRevealTracker';
import VgsShowValue from './VgsInput/VgsShowValue';

export default function KycDisplay({
  kyc,
  onRevealSuccess,
  onRevealFail,
  token,
}: {
  kyc: Kyc;
  onRevealSuccess: () => void;
  onRevealFail: () => void;
  token: string;
}): JSX.Element {
  const onFieldRevealSuccess = useFieldRevealTracker(onRevealSuccess, [
    'firstName',
    'lastName',
  ]);
  return (
    <Fragment>
      <div className='md:flex mb-5'>
        <div className='md:w-1/2 my-2'>
          <VgsShowValue
            value={kyc.firstName}
            label='Legal First Name'
            type='text'
            onRevealSuccess={onFieldRevealSuccess('firstName')}
            onRevealFail={onRevealFail}
            token={token}
          />
        </div>

        <div className='md:w-1/2 my-2'>
          <VgsShowValue
            value={kyc.lastName}
            label='Legal Last Name'
            type='text'
            onRevealSuccess={onFieldRevealSuccess('lastName')}
            onRevealFail={onRevealFail}
            token={token}
          />
        </div>
      </div>
    </Fragment>
  );
}
